import { render } from "./SubscribeIsNeeded.vue?vue&type=template&id=0f3d403b"
import script from "./SubscribeIsNeeded.vue?vue&type=script&lang=js"
export * from "./SubscribeIsNeeded.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__